var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-menu"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{ name: 'siteadmin.public.home' }}},[_vm._v("Public")])],1)])]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }